import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EstimationListComponent } from './estimation-list.component';
import {MatTableModule} from '@angular/material/table';
import {FuseSharedModule} from '../../../@fuse/shared.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';



@NgModule({
    declarations: [EstimationListComponent],
    exports: [
        EstimationListComponent
    ],
    imports: [
        CommonModule,
        MatTableModule,
        FuseSharedModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule
    ]
})
export class EstimationListModule { }
